import {useCallback, useEffect, useRef} from 'react';

import {TTimeout} from 'shared/types';

// Таймер нужен для добавления паузы, чтобы мерцание было не слишком резким
const TIMER_TIMEOUT = 300;

export const useAutoAddOnEmpty = (fieldsLength: number, add: () => void) => {
    const timeoutRef = useRef<TTimeout| null>(null);

    useEffect(() => {
        if (fieldsLength === 0 && !timeoutRef.current) {
            timeoutRef.current = setTimeout(() => {
                add();
                timeoutRef.current = null;
            }, TIMER_TIMEOUT);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [fieldsLength, add]);

    const handleAdd = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        add();
    }, [add]);

    return {handleAdd};
};